import {
  applyMiddleware,
  combineReducers,
  createStore,
  compose,
} from 'redux/es/redux.js';
import { redux } from '@ohif/core';
import thunkMiddleware from 'redux-thunk';

// AZMed reducers
import localStudiesReducer from '../AZmed/LocalStudies/LocalStudiesSlice';
import studiesReducer from '../AZmed/StudiesSlice';
import filtersReducer from '../AZmed/Components/Filter/FiltersSlice';
import { feedbackSlice } from '@azmed-org/azcomponents';
import NavigationReducer from '../AZmed/NavigationSlice';

// Combine our @ohif/core reducers
// Set init data, using values found in localStorage
const { reducers, localStorage, sessionStorage } = redux;
const middleware = [thunkMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  ...reducers,
  feedback: feedbackSlice.reducer,
  localStudies: localStudiesReducer,
  studies: studiesReducer,
  filters: filtersReducer,
  navigation: NavigationReducer,
});

const preloadedState = {
  ...localStorage.loadState(),
  ...sessionStorage.loadState(),
};

// Only `lastFeedbackDate` is meaningful across reloads (drives the feedback
// expiry logic). Drop any persisted `open`/`status` so the modal never
// auto-reopens on load with a stale state shape.
if (preloadedState.feedback) {
  preloadedState.feedback = {
    lastFeedbackDate: preloadedState.feedback.lastFeedbackDate || null,
  };
}

const store = createStore(
  rootReducer,
  preloadedState,
  composeEnhancers(applyMiddleware(...middleware))
);

// When the store's preferences change,
// Update our cached preferences in localStorage
store.subscribe(() => {
  localStorage.saveState({
    preferences: store.getState().preferences,
    feedback: {
      lastFeedbackDate: store.getState().feedback.lastFeedbackDate,
    },
  });

  sessionStorage.saveState({
    servers: store.getState().servers,
  });
});

export default store;
